const routePaths = {
  HOME: '/',
  ABOUT_PROJECT: '/about-project',
  ABOUT: '/about',
  GALLERY: '/gallery',
  EXPLANATION: '/how_it_works',
  LEGALNOTICE: '/legalnotice',
  THEME: '/theme',
  TAGS: '/tags',
  LOCATION: '/location',
  GENERATE: '/generate',
  CARD: '/:id',
  CARD_OLD: '/card/:id',
}

export default routePaths
